<ng-container [ngSwitch]="field_type">
  <app-checkbox-input *ngSwitchCase="fieldTypes.CHECKBOX"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [hideEmptyOption]="hideEmptyOption"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-checkbox-input>

  <app-date-picker-input *ngSwitchCase="fieldTypes.DATE"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-date-picker-input>

  <app-single-date-and-time-picker-input *ngSwitchCase="fieldTypes.DATE_AND_TIME"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-single-date-and-time-picker-input>

  <app-dropdown-input *ngSwitchCase="fieldTypes.DROPDOWN"
    [options]="options"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-dropdown-input>

  <app-multi-select-dropdown-input *ngSwitchCase="fieldTypes.MULTI_SELECT_DROPDOWN"
    [options]="options"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-multi-select-dropdown-input>

  <app-number-input *ngSwitchCase="fieldTypes.NUMBER"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)"
    (isFieldInvalid)="invalidateFieldEvent($event)">
  </app-number-input>

  <app-textarea-input *ngSwitchCase="fieldTypes.MULTI_LINE_TEXT"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-textarea-input>

  <app-rich-textarea-input *ngSwitchCase="fieldTypes.RICH_TEXT"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-rich-textarea-input>

  <app-user-input *ngSwitchCase="fieldTypes.USER"
    [allUsers]="allUsers"
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-user-input>

  <ng-container *ngIf="is_single_input_field">
      <app-single-phone-input *ngSwitchCase="fieldTypes.PHONE"
          [label]="label"
          [name]="name"
          [value]="value"
          [required]="required"
          [disabled]="is_readonly_value"
          [error]="isInvalid"
          [errorText]="errorText"
          [hideOptional]="hideOptional"
          [showLabel]="showLabel"
          (valueChange)="inputValueChangeEvent($event)"
          (isFieldInvalid)="invalidateFieldEvent($event)">
      </app-single-phone-input>
  
    <app-single-email-input *ngSwitchCase="fieldTypes.EMAIL"
      [label]="label"
      [name]="name"
      [value]="value"
      [required]="required"
      [disabled]="is_readonly_value"
      [error]="isInvalid"
      [errorText]="errorText"
      [hideOptional]="hideOptional"
      [showLabel]="showLabel"
      (valueChange)="inputValueChangeEvent($event)"
      (isFieldInvalid)="invalidateFieldEvent($event)">
    </app-single-email-input>
  </ng-container>

  <ng-container *ngIf="!is_single_input_field">
      <app-phone-input *ngSwitchCase="fieldTypes.PHONE"
          [label]="label"
          [name]="name"
          [value]="value"
          [hideOptional]="true"
          [disabled]="is_readonly_value"
          [error]="isInvalid"
          [errorText]="errorText"
          [hideOptional]="hideOptional"
          [showLabel]="showLabel"
          (valueChange)="inputValueChangeEvent($event)">
      </app-phone-input>

      <app-email-input *ngSwitchCase="fieldTypes.EMAIL"
          [label]="label"
          [name]="name"
          [value]="value"
          [hideOptional]="true"
          [disabled]="is_readonly_value"
          [error]="isInvalid"
          [errorText]="errorText"
          [hideOptional]="hideOptional"
          [showLabel]="showLabel"
        (valueChange)="inputValueChangeEvent($event)">
      </app-email-input>
  </ng-container>


  
  <app-text-input *ngSwitchDefault
    [label]="label"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="is_readonly_value"
    [error]="isInvalid"
    [errorText]="errorText"
    [hideOptional]="hideOptional"
    [showLabel]="showLabel"
    (valueChange)="inputValueChangeEvent($event)">
  </app-text-input>
</ng-container>
